import { render, staticRenderFns } from "./group-relationship-approved.vue?vue&type=template&id=a281150a&scoped=true"
import script from "./group-relationship-approved.vue?vue&type=script&lang=js"
export * from "./group-relationship-approved.vue?vue&type=script&lang=js"
import style0 from "./group-relationship-approved.vue?vue&type=style&index=0&id=a281150a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a281150a",
  null
  
)

export default component.exports